export type ListResourcesApiResponseAccessControlList =
  /** status 200  */ ResourceResponseBodyAccessControlList[];
export type TransformedListResourcesApiResponseAccessControlList =
  /** status 200  */ TransformedResourceResponseBodyAccessControlList[];
export type ListResourcesApiArgAccessControlList = void;
export type ListResourceScopeOptionsApiResponseAccessControlList =
  /** status 200  */ AclScopeOptionResponseBodyAccessControlList[];
export type TransformedListResourceScopeOptionsApiResponseAccessControlList =
  /** status 200  */ TransformedAclScopeOptionResponseBodyAccessControlList[];
export type ListResourceScopeOptionsApiArgAccessControlList = {
  resourceId: string;
  scopeId: string;
};
export type ListPermissionsApiArgAccessControlList = {
  roleId: string;
};
export type ListPermissionsApiResponseAccessControlList =
  /** status 200  */ PermissionResponseBodyAccessControlList[];
export type ListUserPermissionsApiResponseAccessControlList =
  /** status 200  */ PermissionResponseBodyAccessControlList[];

export type PermissionResponseBodyAccessControlList = {
  id: string;
  roleId: string;
  resource: PermissionResourceResponseBodyAccessControlList;
  type: PermissionTypeAccessControlList;
  action: PermissionActionResponseBodyAccessControlList | null;
  field: PermissionFieldResponseBodyAccessControlList | null;
  scope: PermissionScopeResponseBodyAccessControlList | null;
};

export type GrantActionPermissionApiResponseAccessControlList = unknown;
export type GrantActionPermissionApiArgAccessControlList =
  GrantActionPermissionRequestBodyAccessControlList;
export type GrantFieldPermissionApiResponseAccessControlList = unknown;

export type UpdateFieldPermissionApiArgAccessControlList =
  GrantFieldPermissionRequestBodyAccessControlList;
export type UpdateFieldPermissionApiResAccessControlList = unknown;
export type UpdateActionPermissionApiArgAccessControlList =
  GrantActionPermissionApiArgAccessControlList;
export type UpdateActionPermissionApiResAccessControlList = unknown;
export type GrantFieldPermissionApiArgAccessControlList =
  GrantFieldPermissionRequestBodyAccessControlList;
export type GrantResourcePermissionApiResponseAccessControlList = unknown;
export type GrantResourcePermissionApiArgAccessControlList =
  GrantResourcePermissionRequestBodyAccessControlList;
export type RevokeResourcePermissionApiResAccessControlList = unknown;
export type RevokeResourcePermissionApiArgAccessControlList =
  GrantResourcePermissionRequestBodyAccessControlList;

export type RevokeAllPermissionApiResAccessControlList = unknown;
export type RevokeAllPermissionApiArgAccessControlList = {roleId: string};
export type GrantAllPermissionApiResAccessControlList = unknown;
export type GrantAllPermissionApiArgAccessControlList = {roleId: string};

export type RevokePermissionApiResponseAccessControlList = /** status 204  */ undefined;
export type RevokePermissionApiArgAccessControlList = {
  id: string;
  roleId: string;
};
export type ListUserPermissionsApiArgAccessControlList = void;
export type AclActionResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type AclFieldResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type TransformedAclActionResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type AclScopeOptionResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type TransformedAclScopeOptionResponseBodyAccessControlList = {
  value: string;
  label: string;
};
export type AclScopeResponseBodyAccessControlList = {
  id: string;
  name: string;
  options: AclScopeOptionResponseBodyAccessControlList[];
};
export type TransformedAclScopeResponseBodyAccessControlList = {
  value: string;
  label: string;
};
export type ResourceResponseBodyAccessControlList = {
  id: string;
  name: string;
  actions: AclActionResponseBodyAccessControlList[];
  fields: AclFieldResponseBodyAccessControlList[];
  scopes: AclScopeResponseBodyAccessControlList[];
  subResources: ResourceResponseBodyAccessControlList[];
};
export type TransformedResourceResponseBodyAccessControlList = {
  id: string;
  name: string;
  actions: TransformedAclActionResponseBodyAccessControlList[];
  fields: TransformedAclActionResponseBodyAccessControlList[];
  scopes: TransformedAclScopeResponseBodyAccessControlList[];
  subResources: TransformedResourceResponseBodyAccessControlList[];
};
export type PermissionResourceResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type PermissionTypeAccessControlList = 'ACTION' | 'FIELD';
export type PermissionActionResponseBodyAccessControlList = {
  id: string;
  name: string;
};

export type GrantActionPermissionRequestBodyAccessControlList = {
  roleId: string;
  resourceId: string;
  actionId: string;
  scope: PermissionScopeRequestBodyAccessControlList | null;
};
export type GrantFieldPermissionRequestBodyAccessControlList = {
  roleId: string;
  resourceId: string;
  fieldId: string;
  scope: PermissionScopeRequestBodyAccessControlList | null;
};
export type GrantResourcePermissionRequestBodyAccessControlList = {
  roleId: string;
  resourceId: string;
};
export type ListUserAllowedResourceActionsApiResponseAccessControlList =
  /** status 200  */ AllowedActionResponseBodyAccessControlList[];
export type AllowedActionResponseBodyAccessControlList = {
  resourceId: string;
  actionId: string;
};
export type ListUserAllowedResourceActionsApiArgAccessControlList = unknown;
export type ListUserAllowedRecordActionsApiResponseAccessControlList =
  /** status 200  */ AllowedActionResponseBodyAccessControlList[];
export type ListUserAllowedRecordActionsApiArgAccessControlList = {
  resourceId: string;
  recordId: string;
};

export type PermissionIdResponseBodyAccessControlList = {
  id: string;
};
export type GrantPermissionApiResponseAccessControlList =
  /** status 201  */ PermissionIdResponseBodyAccessControlList;
export type GrantPermissionApiArgAccessControlList = {
  grantPermissionRequestBody: GrantPermissionRequestBodyAccessControlList;
};
export type GrantPermissionRequestBodyAccessControlList = {
  roleId: string;
  resourceId: string;
  protectedUnitId: string;
  scopes: PermissionScopeRequestBodyAccessControlList[];
};
export type UpdateProtectedUnitPermissionV2ApiResponseAccessControlList = unknown;
export type UpdateProtectedUnitPermissionV2ApiArgAccessControlList = {
  permissionId: string;
  updateActionPermissionRequestBody: UpdateActionPermissionRequestBodyAccessControlList;
};
export type ListPermissionExpressionApiResponseAccessControlList =
  /** status 200  */ PermissionExpressionListResponseBodyAccessControlList;
export type ListPermissionExpressionApiArgAccessControlList = void;
export type PermissionsExpressionScopeResponseBodyAccessControlList = {
  scopeId: string;
  values: string[];
};
export type PermissionsExpressionConditionAlternativeResponseBodyAccessControlList = {
  scopes: PermissionsExpressionScopeResponseBodyAccessControlList[];
};
export type PermissionsExpressionConditionResponseBodyAccessControlList = {
  alternatives: PermissionsExpressionConditionAlternativeResponseBodyAccessControlList[];
};
export type PermissionsExpressionResponseBodyAccessControlList = {
  result: 'ALLOW' | 'DISALLOW' | 'SCOPES_MUST_BE_EVALUATED';
  conditions: PermissionsExpressionConditionResponseBodyAccessControlList[];
};
export type ResourceActionPermissionExpressionResponseBodyAccessControlList = {
  resourceId: string;
  actionId: string;
  permissionsExpression: PermissionsExpressionResponseBodyAccessControlList;
};
export type ResourceFieldPermissionExpressionResponseBodyAccessControlList = {
  resourceId: string;
  fieldId: string;
  permissionsExpression: PermissionsExpressionResponseBodyAccessControlList;
};
export type PermissionExpressionListResponseBodyAccessControlList = {
  actions: ResourceActionPermissionExpressionResponseBodyAccessControlList[];
  fields: ResourceFieldPermissionExpressionResponseBodyAccessControlList[];
};
export type UpdateActionPermissionRequestBodyAccessControlList = {
  scopes: PermissionScopeRequestBodyAccessControlList[];
};
export type PermissionScopeRequestBodyAccessControlList = {
  id: string;
  values: string[];
};
export type ListPermissionsV2ApiResponseAccessControlList =
  /** status 200  */ PermissionV2ResponseBodyAccessControlList[];
export type ListUserPermissionsV2ApiResponseAccessControlList =
  /** status 200  */ UserPermissionV2ResponseBodyAccessControlList[];
export type ListUserPermissionsV2ApiArgAccessControlList = void;
export type PermissionScopeValueResponseBodyAccessControlList = {
  id: string;
  name: string;
};

export type PermissionFieldResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type PutPermissionsApiArgAccessControlList = {
  roleId: string;
  permissions: {
    protectedUnitId: string;
    scopes: PermissionScopeRequestBodyAccessControlList[];
  }[];
};
export type PutPermissionsApiResponseAccessControlList = unknown;
export type ListProtectedUnitsApiResponseAccessControlList =
  /** status 200  */ ProtectedGroupResponseBodyAccessControlList[];
export type ListProtectedUnitsApiArgAccessControlList = void;
export type ProtectedUnitResponseBodyAccessControlList = {
  id: string;
  name: string;
  scopes: ScopeResponseBodyAccessControlList[];
};
export type ScopeResponseBodyAccessControlList = {
  id: string;
  name: string;
  options: ScopeOptionResponseBodyAccessControlList[];
};
export type ScopeOptionResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type ProtectedGroupResponseBodyAccessControlList = {
  id: string;
  name: string;
  protectedUnits: ProtectedUnitResponseBodyAccessControlList[];
  children: ProtectedGroupResponseBodyAccessControlList[];
};

export type UserPermissionV2ResponseBodyAccessControlList = {
  resource: PermissionResourceResponseBodyAccessControlList;
  type: PermissionTypeAccessControlList;
  action: PermissionActionResponseBodyAccessControlList | null;
  field: PermissionFieldResponseBodyAccessControlList | null;
  scopes: PermissionScopeResponseBodyAccessControlList[];
};
export type PermissionScopeResponseBodyAccessControlList = {
  id: string;
  name: string;
  values: PermissionScopeValueResponseBodyAccessControlList[];
};
export type PermissionGroupResponseBodyAccessControlList = {
  id: string;
  name: string;
};
export type PermissionProtectedUnitResponseBodyAccessControlList = {
  id: string;
  name: string;
};

export type ListPermissionsV2ApiArgAccessControlList = {
  roleId: string;
};
export type PermissionV2ResponseBodyAccessControlList = {
  id: string;
  roleId: string;
  group: PermissionGroupResponseBodyAccessControlList;
  protectedUnit: PermissionProtectedUnitResponseBodyAccessControlList;
  scopes: PermissionScopeResponseBodyAccessControlList[];
};
